import { render, staticRenderFns } from "./AuthoringToolView.vue?vue&type=template&id=3d42a84a&"
import script from "./AuthoringToolView.vue?vue&type=script&lang=js&"
export * from "./AuthoringToolView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports